import { Bank, PreferredAccountFormat } from "Infrastructure/Api/Api";
import { z } from "zod";

export const getCompanyBankDetailEditForm = () => {
	return z.object({
		name: z.string().nullish(),
		bankName: z.nativeEnum(Bank).nullish(),
		bankAccount: z.string().nonempty().nullish(),
		iban: z.string().nonempty().nullish(),
		bankCode: z.string().nonempty().nullish(),
		preferredAccountFormat: z
			.nativeEnum(PreferredAccountFormat)
			.optional()
			.nullable(),
	});
};

export type CompanyBankDetailEditFormModel = z.infer<
	ReturnType<typeof getCompanyBankDetailEditForm>
>;
